import React from 'react';
import ColorButton from './ColorButton';
import { getColorIdFromIndex } from '../../lib/FL';
import styles from './ColorButtons.module.scss';

type Props = {
  colors: string[];
  activeColorId: string;
  setActiveColorId: (arg: string) => void;
};

const ColorButtons: React.FC<Props> = ({ colors, activeColorId, setActiveColorId }) => (
  <ul className={styles.colors}>
    {colors.map((color, index) => {
      const colorId = getColorIdFromIndex(index);
      return (
        <li className={styles.color} key={color}>
          <ColorButton
            text={colorId}
            color={color}
            isActive={colorId === activeColorId}
            onClick={() => setActiveColorId(colorId)}
          />
        </li>
      );
    })}
  </ul>
);

export default ColorButtons;
